// lib
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// components
import { Dropdown } from 'primereact/dropdown'

const itemTemplate = option => (option.hidden ? null : <span dangerouslySetInnerHTML={{ __html: option.text }}></span>)

const ViewModes = ({ model, data, onViewModeChange }) => {
  const { viewMode } = model

  return 2 > data.controls.viewModes.options.length || data.controls.viewModes.disabled ? null : (
    <div className={classNames('p-field p-col-param', { 'p-col-param-wide': 'tags' == viewMode })}>
      <Dropdown
        className="p-dropdown-rounded"
        value={viewMode}
        options={data.controls.viewModes.options}
        optionValue="key"
        optionLabel="text"
        optionDisabled="disabled"
        itemTemplate={itemTemplate}
        // valueTemplate={valueTemplate}
        fixedDropdownDir="bottom"
        disabled={data.controls.viewModes.disabled}
        onChange={data.controls.viewModes.disabled ? null : event => onViewModeChange(event.value)}
      />
    </div>
  )
}

ViewModes.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  onViewModeChange: PropTypes.func
}

ViewModes.displayName = 'ViewModes'

export default ViewModes
